// flat roof leak detection: roof sketch, roof catalogue and roof wording (key_detect_roof variants)
export const I18N_ROOF = {
 "de": {
  "szTitle_detect_roof": "Dachskizze",
  "szHint_detect_roof": "Dachfläche aufziehen, Attika oder Dachrand als Kante zeichnen, dann Abläufe, Aufbauten und Messpunkte setzen.",
  "szRoom_detect_roof": "Dachfläche",
  "szRoomName_detect_roof": "Name, z. B. Dach Nord",
  "szWall_detect_roof": "Attika / Kante",
  "szObj_detect_roof": "Dachbauteile",
  "szDmg_detect_roof": "Befunde",
  "szDmgHint_detect_roof": "Fläche aufziehen; Riss oder offene Naht als Linie zeichnen.",
  "szD_wet_detect_roof": "Nasse Dämmung",
  "szD_crack_detect_roof": "Riss / offene Naht",
  "szD_pond": "Stehendes Wasser",
  "szD_blister": "Blase",
  "szG_rdrain": "Entwässerung",
  "szG_rpen": "Aufbauten & Durchdringungen",
  "szG_rmeas": "Messung & Befund",
  "sz_gully": "Dachablauf / Gully",
  "sz_overflow": "Notüberlauf",
  "sz_spout": "Speier",
  "sz_gutter": "Rinne",
  "sz_dome": "Lichtkuppel",
  "sz_hatch": "Dachluke / Ausstieg",
  "sz_chimney": "Kamin",
  "sz_vent": "Lüfter / Entlüftung",
  "sz_pipepen": "Rohrdurchführung",
  "sz_hvac": "Klimagerät",
  "sz_pv": "PV-Feld",
  "sz_rod": "Blitzschutz-Fangstange",
  "sz_anchor": "Anschlagpunkt",
  "sz_mpt": "Feuchte-Messpunkt",
  "sz_smoke": "Rauchgas-Einleitung",
  "sz_tracer": "Tracergas-Einleitung",
  "sz_earth": "Erdung Impulsstrom",
  "sz_core": "Kernbohrung / Prüföffnung",
  "sz_leak": "Leckstelle",
  "pipesTitle_detect_roof": "Dachplan: Kanten, Fugen & Messpunkte",
  "btnDrawPipe_detect_roof": "Kante / Fuge zeichnen",
  "btnAddFitting_detect_roof": "Dachpunkt / Gully setzen",
  "fsPipe_detect_roof": "Kante / Fuge / Ringleitung zeichnen",
  "fsFitting_detect_roof": "Dachpunkt / Gully / Messpunkt setzen",
  "noPipes_detect_roof": "Noch keine Kanten oder Fugen. Tippen Sie auf „Kante / Fuge zeichnen“.",
  "noFittings_detect_roof": "Noch keine Dachpunkte gesetzt.",
  "legendPipes_detect_roof": "Kanten & Fugen",
  "legendFittings_detect_roof": "Dachpunkte",
  "cat_roof": "Flachdach",
  "type_sewer_detect_roof": "Rinne / Fallrohr",
  "type_other_detect_roof": "Attika, Fugen, Ringleitung",
  "fit_tracer_detect_roof": "Tracer-/Rauchgas-Einleitung",
  "fpTitle_detect_roof": "Dachpläne",
  "tgNet_detect_roof": "Dachplan, Bauteile & Zeichnen",
  "btnDrawPipe_survey": "Linie aufnehmen",
  "btnAddFitting_survey": "Messpunkt setzen",
  "noPipes_survey": "Noch keine Aufnahmelinien. Tippen Sie auf „Linie aufnehmen“.",
  "noFittings_survey": "Noch keine Messpunkte gesetzt.",
  "fpNamePh_detect_roof": "Name, z. B. Dach Nord, Anbau",
  "fpEmpty_detect_roof": "Noch kein Dachplan. Foto oder PDF des Plans hochladen – danach mit zwei Punkten den Maßstab setzen.",
  "fpHint_detect_roof": "Auf dem gewählten Dachplan wird statt Luftbild der Plan gezeigt. Neue Punkte und Linien gehören zu diesem Dach; „Luftbild“ zeigt alles.",
  "fpFloor_detect_roof": "Dach"
 },
 "en": {
  "szTitle_detect_roof": "Roof sketch",
  "szHint_detect_roof": "Drag the roof area, draw the parapet or roof edge as an edge, then place drains, roof fixtures and test points.",
  "szRoom_detect_roof": "Roof area",
  "szRoomName_detect_roof": "Name, e.g. roof north",
  "szWall_detect_roof": "Parapet / edge",
  "szObj_detect_roof": "Roof components",
  "szDmg_detect_roof": "Findings",
  "szDmgHint_detect_roof": "Drag an area; draw a crack or open seam as a line.",
  "szD_wet_detect_roof": "Wet insulation",
  "szD_crack_detect_roof": "Crack / open seam",
  "szD_pond": "Ponding water",
  "szD_blister": "Blister",
  "szG_rdrain": "Drainage",
  "szG_rpen": "Fixtures & penetrations",
  "szG_rmeas": "Measurement & findings",
  "sz_gully": "Roof drain / gully",
  "sz_overflow": "Emergency overflow",
  "sz_spout": "Spout",
  "sz_gutter": "Gutter",
  "sz_dome": "Rooflight dome",
  "sz_hatch": "Roof hatch / exit",
  "sz_chimney": "Chimney",
  "sz_vent": "Vent",
  "sz_pipepen": "Pipe penetration",
  "sz_hvac": "HVAC unit",
  "sz_pv": "PV array",
  "sz_rod": "Lightning air terminal",
  "sz_anchor": "Anchor point",
  "sz_mpt": "Moisture test point",
  "sz_smoke": "Smoke injection",
  "sz_tracer": "Tracer gas injection",
  "sz_earth": "Earth point pulse current",
  "sz_core": "Core sample / test opening",
  "sz_leak": "Leak",
  "pipesTitle_detect_roof": "Roof plan: edges, joints & test points",
  "btnDrawPipe_detect_roof": "Draw edge / joint",
  "btnAddFitting_detect_roof": "Place roof point / gully",
  "fsPipe_detect_roof": "Draw edge / joint / perimeter wire",
  "fsFitting_detect_roof": "Place roof point / gully / test point",
  "noPipes_detect_roof": "No edges or joints yet. Tap “Draw edge / joint”.",
  "noFittings_detect_roof": "No roof points placed yet.",
  "legendPipes_detect_roof": "Edges & joints",
  "legendFittings_detect_roof": "Roof points",
  "cat_roof": "Flat roof",
  "type_sewer_detect_roof": "Gutter / downpipe",
  "type_other_detect_roof": "Parapet, joints, perimeter wire",
  "fit_tracer_detect_roof": "Tracer gas / smoke injection",
  "fpTitle_detect_roof": "Roof plans",
  "tgNet_detect_roof": "Roof plan, components & drawing",
  "btnDrawPipe_survey": "Record line",
  "btnAddFitting_survey": "Set survey point",
  "noPipes_survey": "No survey lines yet. Tap “Record line”.",
  "noFittings_survey": "No survey points yet.",
  "fpNamePh_detect_roof": "Name, e.g. roof north, annex",
  "fpEmpty_detect_roof": "No roof plan yet. Upload a photo or PDF of the plan, then set the scale with two points.",
  "fpHint_detect_roof": "The selected roof plan is shown instead of the aerial image. New points and lines belong to this roof; “Aerial” shows everything.",
  "fpFloor_detect_roof": "Roof"
 },
 "it": {
  "szTitle_detect_roof": "Planimetria tetto",
  "szHint_detect_roof": "Traccia l'area del tetto, disegna il parapetto o il bordo come linea, poi posiziona scarichi, elementi e punti di prova.",
  "szRoom_detect_roof": "Area tetto",
  "szRoomName_detect_roof": "Nome, es. tetto nord",
  "szWall_detect_roof": "Parapetto / bordo",
  "szObj_detect_roof": "Elementi tetto",
  "szDmg_detect_roof": "Rilevamenti",
  "szDmgHint_detect_roof": "Traccia un'area; disegna una fessura o giunto aperto come linea.",
  "szD_wet_detect_roof": "Isolante bagnato",
  "szD_crack_detect_roof": "Fessura / giunto aperto",
  "szD_pond": "Ristagno d'acqua",
  "szD_blister": "Bolla",
  "szG_rdrain": "Smaltimento acque",
  "szG_rpen": "Elementi e attraversamenti",
  "szG_rmeas": "Misurazioni e rilevamenti",
  "sz_gully": "Scarico tetto / bocchettone",
  "sz_overflow": "Troppopieno emergenza",
  "sz_spout": "Gocciolatoio",
  "sz_gutter": "Grondaia",
  "sz_dome": "Cupola lucernario",
  "sz_hatch": "Botola / uscita tetto",
  "sz_chimney": "Camino",
  "sz_vent": "Aeratore",
  "sz_pipepen": "Attraversamento tubazioni",
  "sz_hvac": "Unità HVAC",
  "sz_pv": "Impianto fotovoltaico",
  "sz_rod": "Captatore parafulmine",
  "sz_anchor": "Punto di ancoraggio",
  "sz_mpt": "Punto test umidità",
  "sz_smoke": "Iniezione fumo",
  "sz_tracer": "Iniezione gas tracciante",
  "sz_earth": "Punto terra corrente impulsiva",
  "sz_core": "Carotaggio / apertura test",
  "sz_leak": "Infiltrazione",
  "pipesTitle_detect_roof": "Piano tetto: bordi, giunti e punti test",
  "btnDrawPipe_detect_roof": "Disegna bordo / giunto",
  "btnAddFitting_detect_roof": "Posiziona punto tetto / scarico",
  "fsPipe_detect_roof": "Disegna bordo / giunto / filo perimetrale",
  "fsFitting_detect_roof": "Posiziona punto tetto / scarico / punto test",
  "noPipes_detect_roof": "Nessun bordo o giunto. Tocca «Disegna bordo / giunto».",
  "noFittings_detect_roof": "Nessun punto tetto posizionato.",
  "legendPipes_detect_roof": "Bordi e giunti",
  "legendFittings_detect_roof": "Punti tetto",
  "cat_roof": "Tetto piano",
  "type_sewer_detect_roof": "Canale / pluviale",
  "type_other_detect_roof": "Parapetto, giunti, cavo perimetrale",
  "fit_tracer_detect_roof": "Immissione gas tracciante / fumo",
  "fpTitle_detect_roof": "Piante del tetto",
  "tgNet_detect_roof": "Pianta tetto, componenti e disegno",
  "btnDrawPipe_survey": "Rileva linea",
  "btnAddFitting_survey": "Rileva punto",
  "noPipes_survey": "Nessuna linea rilevata. Tocca «Rileva linea».",
  "noFittings_survey": "Nessun punto rilevato.",
  "fpNamePh_detect_roof": "Nome, es. tetto nord, annesso",
  "fpEmpty_detect_roof": "Nessuna pianta del tetto. Carica foto o PDF della pianta, poi imposta la scala con due punti.",
  "fpHint_detect_roof": "Sulla pianta del tetto scelta viene mostrata la pianta invece della foto aerea. Nuovi punti e linee appartengono a questo tetto; «Foto aerea» mostra tutto.",
  "fpFloor_detect_roof": "Tetto"
 },
 "es": {
  "szTitle_detect_roof": "Plano de cubierta",
  "szHint_detect_roof": "Dibuje el área de cubierta, trace el peto o borde como línea, luego coloque sumideros, elementos y puntos de ensayo.",
  "szRoom_detect_roof": "Área de cubierta",
  "szRoomName_detect_roof": "Nombre, ej. cubierta norte",
  "szWall_detect_roof": "Peto / borde",
  "szObj_detect_roof": "Elementos de cubierta",
  "szDmg_detect_roof": "Hallazgos",
  "szDmgHint_detect_roof": "Dibuje un área; trace una grieta o junta abierta como línea.",
  "szD_wet_detect_roof": "Aislamiento húmedo",
  "szD_crack_detect_roof": "Grieta / junta abierta",
  "szD_pond": "Agua estancada",
  "szD_blister": "Ampolla",
  "szG_rdrain": "Drenaje",
  "szG_rpen": "Elementos y penetraciones",
  "szG_rmeas": "Medición y hallazgos",
  "sz_gully": "Sumidero / desagüe",
  "sz_overflow": "Rebosadero de emergencia",
  "sz_spout": "Gárgola",
  "sz_gutter": "Canalón",
  "sz_dome": "Cúpula de lucernario",
  "sz_hatch": "Trampilla / salida",
  "sz_chimney": "Chimenea",
  "sz_vent": "Ventilación",
  "sz_pipepen": "Penetración de tubería",
  "sz_hvac": "Equipo HVAC",
  "sz_pv": "Instalación fotovoltaica",
  "sz_rod": "Pararrayos",
  "sz_anchor": "Punto de anclaje",
  "sz_mpt": "Punto ensayo humedad",
  "sz_smoke": "Inyección de humo",
  "sz_tracer": "Inyección gas trazador",
  "sz_earth": "Punto tierra impulso corriente",
  "sz_core": "Cala / apertura ensayo",
  "sz_leak": "Filtración",
  "pipesTitle_detect_roof": "Plano cubierta: bordes, juntas y puntos ensayo",
  "btnDrawPipe_detect_roof": "Dibujar borde / junta",
  "btnAddFitting_detect_roof": "Colocar punto / sumidero",
  "fsPipe_detect_roof": "Dibujar borde / junta / perímetro cable",
  "fsFitting_detect_roof": "Colocar punto / sumidero / punto ensayo",
  "noPipes_detect_roof": "Sin bordes o juntas aún. Pulse «Dibujar borde / junta».",
  "noFittings_detect_roof": "Sin puntos colocados aún.",
  "legendPipes_detect_roof": "Bordes y juntas",
  "legendFittings_detect_roof": "Puntos de cubierta",
  "cat_roof": "Cubierta plana",
  "type_sewer_detect_roof": "Canalón / bajante",
  "type_other_detect_roof": "Peto, juntas, cable perimetral",
  "fit_tracer_detect_roof": "Inyección de gas trazador / humo",
  "fpTitle_detect_roof": "Planos de cubierta",
  "tgNet_detect_roof": "Plano de cubierta, elementos y dibujo",
  "btnDrawPipe_survey": "Levantar línea",
  "btnAddFitting_survey": "Colocar punto de medición",
  "noPipes_survey": "Aún no hay líneas. Toque «Levantar línea».",
  "noFittings_survey": "Aún no hay puntos de medición.",
  "fpNamePh_detect_roof": "Nombre, p. ej. cubierta norte, anexo",
  "fpEmpty_detect_roof": "Aún no hay plano de cubierta. Suba una foto o PDF del plano y fije la escala con dos puntos.",
  "fpHint_detect_roof": "En el plano de cubierta elegido se muestra el plano en lugar de la foto aérea. Los nuevos puntos y líneas pertenecen a esta cubierta; «Foto aérea» muestra todo.",
  "fpFloor_detect_roof": "Cubierta"
 },
 "pt": {
  "szTitle_detect_roof": "Esquiço da cobertura",
  "szHint_detect_roof": "Arraste a área da cobertura, desenhe o platibanda ou remate como aresta, depois coloque ralos, elementos da cobertura e pontos de ensaio.",
  "szRoom_detect_roof": "Área da cobertura",
  "szRoomName_detect_roof": "Nome, ex. cobertura norte",
  "szWall_detect_roof": "Platibanda / remate",
  "szObj_detect_roof": "Elementos da cobertura",
  "szDmg_detect_roof": "Anomalias",
  "szDmgHint_detect_roof": "Arraste uma área; desenhe uma fenda ou junta aberta como linha.",
  "szD_wet_detect_roof": "Isolamento húmido",
  "szD_crack_detect_roof": "Fenda / junta aberta",
  "szD_pond": "Água empoçada",
  "szD_blister": "Bolha",
  "szG_rdrain": "Drenagem",
  "szG_rpen": "Elementos e penetrações",
  "szG_rmeas": "Medição e anomalias",
  "sz_gully": "Ralo / sumidouro",
  "sz_overflow": "Extravasor de emergência",
  "sz_spout": "Bica",
  "sz_gutter": "Caleira",
  "sz_dome": "Claraboia cúpula",
  "sz_hatch": "Alçapão / saída",
  "sz_chimney": "Chaminé",
  "sz_vent": "Ventilador",
  "sz_pipepen": "Penetração de tubagem",
  "sz_hvac": "Unidade AVAC",
  "sz_pv": "Painel fotovoltaico",
  "sz_rod": "Para-raios",
  "sz_anchor": "Ponto de ancoragem",
  "sz_mpt": "Ponto de ensaio humidade",
  "sz_smoke": "Injeção de fumo",
  "sz_tracer": "Injeção de gás traçador",
  "sz_earth": "Ponto terra corrente pulsada",
  "sz_core": "Carote / abertura ensaio",
  "sz_leak": "Infiltração",
  "pipesTitle_detect_roof": "Planta da cobertura: remates, juntas e pontos de ensaio",
  "btnDrawPipe_detect_roof": "Desenhar remate / junta",
  "btnAddFitting_detect_roof": "Colocar ponto / ralo",
  "fsPipe_detect_roof": "Desenhar remate / junta / fio perímetro",
  "fsFitting_detect_roof": "Colocar ponto / ralo / ponto ensaio",
  "noPipes_detect_roof": "Ainda sem remates ou juntas. Toque em «Desenhar remate / junta».",
  "noFittings_detect_roof": "Ainda sem pontos colocados.",
  "legendPipes_detect_roof": "Remates e juntas",
  "legendFittings_detect_roof": "Pontos da cobertura",
  "cat_roof": "Cobertura plana",
  "type_sewer_detect_roof": "Caleira / tubo de queda",
  "type_other_detect_roof": "Platibanda, juntas, cabo perimetral",
  "fit_tracer_detect_roof": "Injeção de gás traçador / fumo",
  "fpTitle_detect_roof": "Plantas da cobertura",
  "tgNet_detect_roof": "Planta da cobertura, elementos e desenho",
  "btnDrawPipe_survey": "Levantar linha",
  "btnAddFitting_survey": "Colocar ponto de medição",
  "noPipes_survey": "Ainda sem linhas. Toque em «Levantar linha».",
  "noFittings_survey": "Ainda sem pontos de medição.",
  "fpNamePh_detect_roof": "Nome, p. ex. cobertura norte, anexo",
  "fpEmpty_detect_roof": "Ainda sem planta da cobertura. Carregue foto ou PDF da planta e defina a escala com dois pontos.",
  "fpHint_detect_roof": "Na planta da cobertura escolhida é mostrada a planta em vez da foto aérea. Novos pontos e linhas pertencem a esta cobertura; «Foto aérea» mostra tudo.",
  "fpFloor_detect_roof": "Cobertura"
 },
 "fr": {
  "szTitle_detect_roof": "Plan de toiture",
  "szHint_detect_roof": "Délimitez la surface de toiture, tracez l'acrotère ou le bord comme contour, puis placez les évacuations, équipements et points de mesure.",
  "szRoom_detect_roof": "Surface de toiture",
  "szRoomName_detect_roof": "Nom, ex. toiture nord",
  "szWall_detect_roof": "Acrotère / bord",
  "szObj_detect_roof": "Équipements de toiture",
  "szDmg_detect_roof": "Constats",
  "szDmgHint_detect_roof": "Délimitez une zone ; tracez une fissure ou joint ouvert comme ligne.",
  "szD_wet_detect_roof": "Isolant humide",
  "szD_crack_detect_roof": "Fissure / joint ouvert",
  "szD_pond": "Eau stagnante",
  "szD_blister": "Cloque",
  "szG_rdrain": "Évacuation",
  "szG_rpen": "Équipements & traversées",
  "szG_rmeas": "Mesure & constats",
  "sz_gully": "Évacuation EP / avaloir",
  "sz_overflow": "Trop-plein de sécurité",
  "sz_spout": "Gargouille",
  "sz_gutter": "Chéneau",
  "sz_dome": "Dôme d'éclairage zénithal",
  "sz_hatch": "Trappe / sortie de toit",
  "sz_chimney": "Cheminée",
  "sz_vent": "Ventilation",
  "sz_pipepen": "Traversée de conduit",
  "sz_hvac": "Unité CVC",
  "sz_pv": "Installation PV",
  "sz_rod": "Tige paratonnerre",
  "sz_anchor": "Point d'ancrage",
  "sz_mpt": "Point de mesure d'humidité",
  "sz_smoke": "Injection de fumée",
  "sz_tracer": "Injection gaz traceur",
  "sz_earth": "Point de terre impulsion",
  "sz_core": "Carotte / ouverture de contrôle",
  "sz_leak": "Fuite",
  "pipesTitle_detect_roof": "Plan de toiture : bords, joints & points de mesure",
  "btnDrawPipe_detect_roof": "Tracer bord / joint",
  "btnAddFitting_detect_roof": "Placer point / évacuation",
  "fsPipe_detect_roof": "Tracer bord / joint / fil périmétrique",
  "fsFitting_detect_roof": "Placer point / évacuation / point de mesure",
  "noPipes_detect_roof": "Aucun bord ou joint. Appuyez sur « Tracer bord / joint ».",
  "noFittings_detect_roof": "Aucun point de toiture placé.",
  "legendPipes_detect_roof": "Bords & joints",
  "legendFittings_detect_roof": "Points de toiture",
  "cat_roof": "Toiture-terrasse",
  "type_sewer_detect_roof": "Chéneau / descente",
  "type_other_detect_roof": "Acrotère, joints, câble périmétrique",
  "fit_tracer_detect_roof": "Injection gaz traceur / fumée",
  "fpTitle_detect_roof": "Plans de toiture",
  "tgNet_detect_roof": "Plan de toiture, éléments et dessin",
  "btnDrawPipe_survey": "Lever une ligne",
  "btnAddFitting_survey": "Placer un point levé",
  "noPipes_survey": "Aucune ligne levée. Touchez « Lever une ligne ».",
  "noFittings_survey": "Aucun point levé.",
  "fpNamePh_detect_roof": "Nom, p. ex. toiture nord, annexe",
  "fpEmpty_detect_roof": "Pas encore de plan de toiture. Importez une photo ou un PDF du plan, puis fixez l’échelle avec deux points.",
  "fpHint_detect_roof": "Le plan de toiture choisi remplace la vue aérienne. Les nouveaux points et lignes appartiennent à cette toiture ; « Vue aérienne » montre tout.",
  "fpFloor_detect_roof": "Toiture"
 },
 "sq": {
  "szTitle_detect_roof": "Skica e çatisë",
  "szHint_detect_roof": "Tërhiqni sipërfaqen e çatisë, vizatoni parapetet ose skajin e çatisë si buzë, më pas vendosni shkarkimet, pajisjet e çatisë dhe pikat e testimit.",
  "szRoom_detect_roof": "Sipërfaqja e çatisë",
  "szRoomName_detect_roof": "Emri, p.sh. çati veri",
  "szWall_detect_roof": "Parapet / skaj",
  "szObj_detect_roof": "Komponentët e çatisë",
  "szDmg_detect_roof": "Gjetjet",
  "szDmgHint_detect_roof": "Tërhiqni një zonë; vizatoni një të çarë ose bashkim të hapur si vijë.",
  "szD_wet_detect_roof": "Izolim i lagësht",
  "szD_crack_detect_roof": "Të çarë / bashkim i hapur",
  "szD_pond": "Ujë i mbledhur",
  "szD_blister": "Flluskë",
  "szG_rdrain": "Kullimi",
  "szG_rpen": "Pajisje & depërtime",
  "szG_rmeas": "Matje & gjetje",
  "sz_gully": "Shkarkues çatie / grilë",
  "sz_overflow": "Shkarkues emergjence",
  "sz_spout": "Gojë uji",
  "sz_gutter": "Uluk",
  "sz_dome": "Kubë dritare çatie",
  "sz_hatch": "Derë çatie / dalje",
  "sz_chimney": "Oxhak",
  "sz_vent": "Ventilim",
  "sz_pipepen": "Depërtim gypash",
  "sz_hvac": "Njësi HVAC",
  "sz_pv": "Sistem fotovoltaik",
  "sz_rod": "Rrufepritës",
  "sz_anchor": "Pikë ankorimi",
  "sz_mpt": "Pikë testimi lagështie",
  "sz_smoke": "Pikë injektimi tymi",
  "sz_tracer": "Pikë injektimi gazi gjurmues",
  "sz_earth": "Pikë tokëzimi rryma impulsi",
  "sz_core": "Mostër bërthamë / hapje testimi",
  "sz_leak": "Rrjedhje",
  "pipesTitle_detect_roof": "Plani i çatisë: skajet, bashkimet & pikat e testimit",
  "btnDrawPipe_detect_roof": "Vizato skaj / bashkim",
  "btnAddFitting_detect_roof": "Vendos pikë çatie / grilë",
  "fsPipe_detect_roof": "Vizato skaj / bashkim / tel perimetral",
  "fsFitting_detect_roof": "Vendos pikë çatie / grilë / pikë testimi",
  "noPipes_detect_roof": "Asnjë skaj ose bashkim ende. Shtypni «Vizato skaj / bashkim».",
  "noFittings_detect_roof": "Asnjë pikë çatie e vendosur ende.",
  "legendPipes_detect_roof": "Skajet & bashkimet",
  "legendFittings_detect_roof": "Pikat e çatisë",
  "cat_roof": "Çati e sheshtë",
  "type_sewer_detect_roof": "Ulluk / tub shkarkimi",
  "type_other_detect_roof": "Parapet, fuga, kabllo perimetrale",
  "fit_tracer_detect_roof": "Futje gazi gjurmues / tymi",
  "fpTitle_detect_roof": "Planet e çatisë",
  "tgNet_detect_roof": "Plani i çatisë, elementet dhe vizatimi",
  "btnDrawPipe_survey": "Rilevo vijë",
  "btnAddFitting_survey": "Vendos pikë matjeje",
  "noPipes_survey": "Ende pa vija. Prekni «Rilevo vijë».",
  "noFittings_survey": "Ende pa pika matjeje.",
  "fpNamePh_detect_roof": "Emri, p.sh. çatia veri, aneksi",
  "fpEmpty_detect_roof": "Ende pa plan çatie. Ngarkoni foto ose PDF të planit, pastaj vendosni shkallën me dy pika.",
  "fpHint_detect_roof": "Në planin e zgjedhur të çatisë shfaqet plani në vend të fotos ajrore. Pikat dhe vijat e reja i përkasin kësaj çatie; «Foto ajrore» shfaq gjithçka.",
  "fpFloor_detect_roof": "Çati"
 }
};
